export default __webpack_public_path__ + "static/media/slider-scene.8796812e.png";